import {
  formatTemplateRate,
  formatTemplateTotal,
  templateCategoryLabel,
  type BroadcastCostEstimate,
} from "@school-sales-ai/shared";

/**
 * What this send will cost, in words.
 *
 * One component rendered TWICE — on the template step and again on the confirm
 * step — rather than two copies of the sentence. The confirm step used to show a
 * bare total with no category and no rate, so the person approving the spend
 * could not see which of Meta's two prices they were approving, and the utility
 * caveat was only visible two screens earlier. Whoever confirms a broadcast is
 * often not whoever wrote the template.
 */
export function BroadcastCostNote({
  estimate,
  category,
}: {
  estimate: BroadcastCostEstimate | null;
  category: string;
}): React.JSX.Element {
  return (
    <div className="rounded-md bg-ink-050 p-3 text-sm text-ink-700">
      {estimate?.knownCategory ? (
        <>
          Costo estimado:{" "}
          <strong>{formatTemplateTotal(estimate.total, estimate.currency)}</strong> ·{" "}
          {formatTemplateRate(estimate.unitCost, estimate.currency)} por mensaje (
          {templateCategoryLabel(category)} · tarifa de Meta a {estimate.asOf})
        </>
      ) : (
        // Never a block: refusing a send over OUR stale rate table would be
        // worse than sending without a number. See `estimateBroadcastCost`.
        "No podemos estimar el costo de esta plantilla: su categoría no está en nuestra tarifa."
      )}
      {category === "UTILITY" ? (
        <p className="mt-1 text-xs text-ink-500">
          Las plantillas de utilidad no se cobran si el prospecto te escribió en las
          últimas 24 horas, así que el costo real puede ser menor.
        </p>
      ) : null}
    </div>
  );
}
